import { keys } from "./Keys";
import { RestError } from "../../services/rest-service/RestService";
import { BaseUseQueryParameters } from "../BaseUseQueryParameters";
import { useQuery } from "react-query";
import { IReferenceDTO } from "../../services/notification-list-data-service/Models";
import NotificationListDataService from "../../services/notification-list-data-service/NotificationListService";

export type UseNotificationListReferenceDataParms = {
    groupID: number,
    organizationID: number,
} & BaseUseQueryParameters<IReferenceDTO | undefined>;

export function useNotificationListReferenceData({
    groupID,
    organizationID,
    enabled,    
    onSuccess,
    onError
}: UseNotificationListReferenceDataParms) {
    return useQuery<IReferenceDTO, RestError>(
        keys.referenceData(groupID, 
            organizationID,
        ),
        ({ signal }) => {
            return NotificationListDataService.getReferenceData(
                groupID, 
                organizationID,
                signal
            );
        },
        {
            enabled,
            onError: onError,
            onSuccess: onSuccess,
            //refetchInterval: refreshSeconds ? refreshSeconds * 1000 : false,
            refetchInterval: false,
            //staleTime: 0,
            staleTime: Infinity,
            refetchOnWindowFocus: false,
            refetchOnMount: true,
            refetchOnReconnect: false,
            retry: false,

        }
    );
}